import  gql  from 'graphql-tag'

export const TOKEN_AUTH = gql`mutation tokenAuth($input: ObtainJSONWebTokenInput!){
    tokenAuth(input: $input){
        token
        refreshToken
        idleTime
        daysResume
        alert
        salary
        ipc
        health
        pension
        arl
        compensation
        severancePayInterest
        ageForAssurance
        ageForAssurancePercentBelow
        ageForAssurancePercentAbove
        user{
            name
            surname
            username
            creditanalyst{
                office{
                    email
                }
            }
            group{
                name
                permissions{
                edges{
                    node{
                    name
                    }
                }
                }
            }
        }
    }
}`;